export const NUMBER_OF_CAROUSEL_IMAGES = 16
export const NUMBER_OF_CAROUSEL_IMAGES_INTERVAL = 2